import { render, staticRenderFns } from "./AquacultureDashboard.vue?vue&type=template&id=8e7dfdf6&scoped=true"
import script from "./AquacultureDashboard.vue?vue&type=script&lang=js"
export * from "./AquacultureDashboard.vue?vue&type=script&lang=js"
import style0 from "./AquacultureDashboard.vue?vue&type=style&index=0&id=8e7dfdf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7dfdf6",
  null
  
)

export default component.exports